'use client';

import { Fragment } from 'react';
import { Container } from '@/components/common/container';
import { ImpressumContent } from '@/app/(protected)/impressum/content';

export default function ImpressumPageClient() {
  return (
    <Fragment>
      <Container>
        <ImpressumContent />
      </Container>
    </Fragment>
  );
}
